<template>
  <!--Utilisation Curio : Unit style card, for item, theme, playlist-->
  <article
    class="rc-card-unit"
    :class="{
      'rc-expired-unit': isExpired(item)
    }"
  >
    <div v-if="isStacked" class="rc-stack-effect"></div>
    <div class="rc-thumbnail-wrapper" aria-hidden="true">
      <RcImgLazy
        class="img-fluid w-100"
        :src="imgThumbnail(item)"
        alt=""
        @error="imageUrlFallback"
      ></RcImgLazy>
    </div>

    <div class="rc-card-body">
      <div class="rc-card-text">
        <header>
          <div class="rc-sur-title">
            <span v-if="item.group_item"> {{ item.group_item.name }}</span>

            <span v-else-if="displayOwnerName(item.content_owner)">
              {{ item.content_owner.name }}
            </span>
          </div>

          <h3 class="h4">
            <router-link
              :to="toLink"
              class="stretched-link"
              @keydown.tab.exact="onKeydownTab"
              @keydown.shift.tab="onKeydownShiftTab"
            >
              {{ item.title || item.name }}
            </router-link>
          </h3>
        </header>
        <template v-if="variant == 'item'">
          <template v-if="isExpired(item)">
            <div class="rc-tag-end-rights">
              <img :src="icWarningRed" :alt="$t('common.warning')" />{{
                $t("rights.end.tag")
              }}
            </div></template
          ><template v-else>
            <ul class="rc-list-border" role="presentation">
              <li>{{ item.item_type }}</li>
              <li>
                <span class="visually-hidden"
                  >{{ $t("catalog.produced_in") }}&nbsp;</span
                >{{ item.year }}
              </li>
              <li v-if="getItemAudiencesShort(item)">
                <span class="visually-hidden"
                  >{{ $t("common.recommended_for") }}&nbsp;</span
                >
                {{
                  $t("catalog.short_audience." + getItemAudiencesShort(item))
                }}
              </li>
            </ul>
          </template></template
        >
        <template v-if="variant == 'playlist'">
          <ul class="rc-list-border">
            <li>
              {{
                $tc(`catalog.titles`, item.nb_screeners, {
                  n: item.nb_screeners
                })
              }}
            </li>
          </ul></template
        >
      </div>

      <span
        v-if="variant == 'item' && !isExpired(item)"
        class="rc-duration"
        :title="useLocaleDuration(item.duration, $i18n.locale)"
      >
        {{ useShortDuration(item.duration) }}
      </span>
    </div>
  </article>
</template>

<script>
import icWarningRed from "#/assets/img/icons/ic_warning_red.svg";

import { catalogItemMixin } from "@/libvue/apps/catalog/mixins/itemMixin";
import RcImgLazy from "@/libvue/components/image/ImageLazy.vue";
import {
  useLocaleDuration,
  useShortDuration
} from "@/libvue/composables/durations";

export default {
  name: "RcCardUnit",
  components: {
    RcImgLazy
  },
  mixins: [catalogItemMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isStacked: {
      type: Boolean,
      default: false,
      required: false
    },
    //item, theme, playlist
    variant: {
      type: String,
      default: "item",
      required: false
    }
  },
  emits: ["keydownTab", "keydownShiftTab"],
  setup() {
    return { useLocaleDuration, useShortDuration, icWarningRed };
  },
  computed: {
    toLink() {
      //theme
      if (this.variant == "theme") {
        return {
          name: "catalog.themes.detail",
          params: {
            uid: this.item.uid,
            locale: this.$i18n.locale
          }
        };
      }
      //playlist
      else if (this.variant == "playlist") {
        return {
          name: "user.playlists.detail",
          params: {
            uid: this.item.uid,
            locale: this.$i18n.locale
          }
        };
      }
      //type
      else if (this.variant == "type") {
        return {
          name: "catalog.group.slug",
          params: {
            uid: this.item.uid,
            locale: this.$i18n.locale
          }
        };
      }

      //item
      else {
        return {
          name: "catalog.item.detail",
          params: {
            uid: this.item.uid,
            locale: this.$i18n.locale
          }
        };
      }
    }
  },

  methods: {
    onKeydownTab(e) {
      this.$emit("keydownTab", e);
    },
    onKeydownShiftTab(e) {
      this.$emit("keydownShiftTab", e);
    }
  }
};
</script>

<style lang="scss"></style>
